import React from 'react';
import { json, useNavigate } from "react-router-dom";
import {Box, Grid} from '@material-ui/core';
///import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ButtonBase from '@mui/material/ButtonBase';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import LinearProgress from '@mui/material/LinearProgress';
import Alert from '../components/Alert';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefAlert = React.useRef(); 
	const [dataLoading, setDataLoading] = React.useState(true);
	
	const [rows, setRows] = React.useState([]);
	const [columnGraphList, setColumnGraphList] = React.useState([]);
	const [forecastingList, setForecastingList] = React.useState([]);
	const [columnGraphTarget, setColumnGraphTarget] = React.useState({});
	const [birthdayList, setBirthdayList] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [alertMessage, setAlertMessage] = React.useState("");

	
	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){
			getApiData();
		}
	}, [userObj]);

	async function getApiData(){ 
		  let apiUrl=API_URL+'/crm-dashboard-leads';
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){ 
					////document.write(JSON.stringify(response.data)); 
				 	setRows(response.data.obj.cardList);
					setColumnGraphList(response.data.obj.columnGraphList);
					setColumnGraphTarget(response.data.obj.target);
					setForecastingList(response.data.obj.forecasting);
					setBirthdayList(response.data.obj.birthdays);

				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else if(response && response.data && response.data.responseTxt==="notFound"){
					navigate('/leads');
				}
			}).catch((error) => {
				console.log(""+error);
				//setSeverityAlert("error");
				///setAlertMessage(""+error);			
          		//childRefAlert.current.handleClickOpen();	
				return false;
		  	})	
	}

	function goToList(url) {
		//alert(url);
		let urlArr = url.split('?');
		const params = {}
		if(urlArr[1]){
			let pArr = urlArr[1].split('&');
			let vArr = [];
			for(let i=0; i<pArr.length; i++){
				vArr = pArr[i].split('=');
				params[vArr[0]] = vArr[1];
			}
		}
		navigate('/'+urlArr[0],{state:params});
	}	
	
	

	
	return (
		<div> 
				<MetaTags>
            		<title>Dashboard</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Dashboard" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox' mb={5} >	

				    <Box mt={1} mb={1} >
						<Grid container spacing={2}>
							{rows?rows.map((row)=>(
								<div key={row.key} className='cardboxouter' >
								<ButtonBase onClick={()=>{goToList(row.url)}} title={row.tooltip} >
									<Card className='cardbox' >
										<CardContent >
											<h5 color="text.secondary">
												{row.key}
											</h5>
											<h1 className='bottomContent'>
												{row.value}
											</h1>											
										</CardContent>
									</Card>
								</ButtonBase>
								</div>	
  							)):null}
						</Grid>
					</Box>

					<Box mt={1} mb={1} >
						<Grid container spacing={2}>
							<Grid item md={6} xs={12} >
								<b style={{color:'#666'}} >Forecasting</b>
								<div>
								{(forecastingList && forecastingList.length>0)?	
									<HighchartsReact
										highcharts={Highcharts}
										options={{credits: false,chart:{type: 'pie'},title:{text: ''},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ''},plotOptions : {pie: {allowPointSelect: true,cursor: '',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y}'}}},series: [{showInLegend: true,name: '',data: forecastingList}]}}
									/>
								:<div style={{backgroundColor:'#F7F7F7',padding:10,height:150,borderRadius:10}} >No Forecasting Graph Available</div>}	
								</div>
							</Grid>
							<Grid item md={6} xs={12} >
								<b style={{color:'#666'}} >Target v/s Deals Won v/s Probability</b>
								<div>
								{(columnGraphTarget && columnGraphTarget.xaxis && columnGraphTarget.xaxis.length>0)?	
									<HighchartsReact
										highcharts={Highcharts}
										options={{credits: false,chart: {type: 'column'},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ' ',formatter: function() {return '<b>'+this.x+'</b><br/>&#8377;'+this.y}},xAxis: {categories: columnGraphTarget.xaxis,},yAxis: {title: {text: ' '},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' ' : this.y + ' '}}}},series: [{cursor: '',point: {events: {click: function () {}}},showInLegend: false,name: 'Count ',title:null, data: columnGraphTarget.yaxis}]}}
									/>
								:<div style={{backgroundColor:'#F7F7F7',padding:10,height:150,borderRadius:10}} >No Target Graph Available</div>}	
								</div>
							</Grid>
							
							
						</Grid>
					</Box>	

				{(columnGraphList && columnGraphList.length>0)?				
					<Box mt={1}>
						<Grid container spacing={2}>
						{columnGraphList.map((row)=>(	
							<Grid item md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={{credits: false,chart: {type: 'column'},title: {text: '<span style="font-size:13px;font-weight:bold;color:#666;" >'+row.title+'</span>'},caption: {text: ''},tooltip: {valueSuffix: ' ',formatter: function() {return '<b>'+this.x+'</b><br/>Leads:'+this.y+'<br/>Value:'+this.point.totalValue}},xAxis: {categories: row.xaxis,},yAxis: {title: {text: ' '},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + ' ' : this.y + ' '}}}},series: [{cursor: 'pointer',point: {events: {click: function () {goToList(this.options.url)}}},showInLegend: false,name: 'Count ',title:null, data: row.yaxis}]}}
								/>
							</Grid>
						))}
						</Grid>
					</Box>
				:null}	


				</Box>
				


				<Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />				
			
		</div>	
	);
  }